
<ul class="navview-menu" *ngIf="view == 'reglement'">
  <li class="item clickable active">
    <a (click)="onFilter('ALL')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'ALL' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('ATTENTE')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'WAITING' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('VALIDER')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'VALIDATE' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('REJETER')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'REJECT' |translate }}</span>
    </a>
  </li>
</ul>

<ul class="navview-menu" *ngIf="view == 'bon_de_commande'">
  <li class="item clickable active">
    <a (click)="onFilter('ALL')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'ALL' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('ATTENTE')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'WAITING' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('VALIDER')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'VALIDATE' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('REJETER')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'REJECT' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('ANNULER')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'CANCEL' |translate }}</span>
    </a>
  </li>
<!--  <li class="item clickable">-->
<!--    <a (click)="onFilter('REGLER')">-->
<!--      <span class="icon"><span class="mif-paper-plane"></span></span>-->
<!--      <span class="caption">{{'REGULATE' |translate }}</span>-->
<!--    </a>-->
<!--  </li>-->
</ul>

<ul class="navview-menu" *ngIf="view == 'reclamation'">
  <li class="item clickable active">
    <a (click)="onFilter('ALL')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'ALL' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('ATTENTE')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'WAITING' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('TRAITER')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'PROCESSED' |translate }}</span>
    </a>
  </li>
  <li class="item clickable">
    <a (click)="onFilter('ANNULER')">
      <span class="icon"><span class="mif-paper-plane"></span></span>
      <span class="caption">{{'CANCEL' |translate }}</span>
    </a>
  </li>
</ul>

<ul class="navview-menu" *ngIf="view == 'config-gene-tourne'">

  <!-- ── Gestion opérationnelle ── -->
  <li class="item clickable" [ngClass]="{'active': currentItem === 'DASHBOARD'}">
    <a (click)="onFilter('DASHBOARD')">
      <span class="icon"><span class="mif-home"></span></span>
      <span class="caption">{{'Dashboard' |translate }}</span>
    </a>
  </li>
  <li class="item clickable" [ngClass]="{'active': currentItem === 'COMMERCIAUX'}">
    <a (click)="onFilter('COMMERCIAUX')">
      <span class="icon"><span class="mif-users"></span></span>
      <span class="caption">{{'Commerciaux' |translate }}</span>
    </a>
  </li>
  <li class="item clickable" [ngClass]="{'active': currentItem === 'CLIENT'}">
    <a (click)="onFilter('CLIENT')">
      <span class="icon"><span class="mif-user"></span></span>
      <span class="caption">{{'Client' |translate }}</span>
    </a>
  </li>
  <li class="item clickable" [ngClass]="{'active': currentItem === 'TOURNEES'}">
    <a (click)="onFilter('TOURNEES')">
      <span class="icon"><span class="mif-map"></span></span>
      <span class="caption">{{'Tournées' |translate }}</span>
    </a>
  </li>
  <li class="item clickable" [ngClass]="{'active': currentItem === 'ZONES'}">
    <a (click)="onFilter('ZONES')">
      <span class="icon"><span class="mif-location"></span></span>
      <span class="caption">{{ 'ZC.MENU' | translate }}</span>
    </a>
  </li>
  <li class="item clickable" [ngClass]="{'active': currentItem === 'TYPE_VISITE'}">
    <a (click)="onFilter('TYPE_VISITE')">
      <span class="icon"><span class="mif-eye"></span></span>
      <span class="caption">{{ 'TV.MENU' | translate }}</span>
    </a>
  </li>
  <li class="item clickable" [ngClass]="{'active': currentItem === 'PRE-VENTE'}">
    <a (click)="onFilter('PRE-VENTE')">
      <span class="icon"><span class="mif-cart"></span></span>
      <span class="caption">{{'Pré vente' |translate }}</span>
    </a>
  </li>
  <li class="item clickable" [ngClass]="{'active': currentItem === 'VENTE'}">
    <a (click)="onFilter('VENTE')">
      <span class="icon"><span class="mif-store"></span></span>
      <span class="caption">{{'Vente direct' |translate }}</span>
    </a>
  </li>

  <!-- ── Configuration ── -->
<!--  <li class="item-separator"></li>-->
<!--  <li class="group-title">{{ 'STRUCT.CONFIGURATION' | translate }}</li>-->

<!--  <li class="item clickable" [ngClass]="{'active': currentItem === 'PROCHAINES_ACTIONS'}">-->
<!--    <a (click)="onFilter('PROCHAINES_ACTIONS')">-->
<!--      <span class="icon"><span class="mif-rocket"></span></span>-->
<!--      <span class="caption">{{ 'PA.MENU' | translate }}</span>-->
<!--    </a>-->
<!--  </li>-->

</ul>
